export default "__VITE_ASSET__aa95dfc1__"